import "./ProfileSites.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ProfileSitesComponentController from "./ProfileSitesComponentController";

export default class ProfileSitesComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            profile: "<",
        };
        this.controller = ProfileSitesComponentController;
        this.templateUrl = "/App/Modules/Auth/Components/Profile/Sites/ProfileSites.html";
    }
}

module("mmAuth").component("mmProfileSites", new ProfileSitesComponent());
